import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Table,
  Input,
  Button,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// Redux
import { Link, useParams } from "react-router-dom";
import { getConsignment } from "connection/backend";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";
import Pagination3 from "components/Common/Pagination3";

const AccountDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [consignments, setConsignments] = useState([]);
  const [createdDateRange, setCreatedDateRange] = useState([]);

  const getData = async (changeUrl) => {
    setLoading(true);
    const response = await getConsignment({ changeUrl });
    setConsignments(response.data.consignments);
    setLoading(false);
  };

  useEffect(() => {
    let url = `?search=${id}&created_date_after=&created_date_before=`;
    getData(url);
  }, []);

  const onChange1 = (createdDateRange) => {
    setCreatedDateRange(createdDateRange);
  };

  const resetFilter = () => {
    setCreatedDateRange("");
    let url = `?search=${id}&created_date_after=&created_date_before=`;
    getData(url);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    let url = `?search=${id}&created_date_after=${date_1}&created_date_before=${date_2}`;
    getData(url);
  };

  console.log(consignments);
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Reportes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Reportes"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              <Card
                style={{
                  width: "75rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">
                    Detalle de movimientos cliente {id}
                  </h2>
                </CardTitle>
                <Form onSubmit={onSubmit}>
                  <Row className="justify-content-md-start ms-4 mb-3 ps-3">
                    <Col lg={2}>
                      <InputGroup>
                        <Flatpickr
                          className="form-control"
                          placeholder="dd/mm/aaaa"
                          value={createdDateRange}
                          onChange={onChange1}
                          options={{
                            mode: "range",
                            dateFormat: "d/m/Y",
                            locale: Spanish,
                          }}
                        />
                      </InputGroup>
                    </Col>
                    <Col lg={2}>
                      <Button color="primary" type="submit">
                        Aplicar
                      </Button>
                      {createdDateRange !== "" ? (
                        <Button
                          className="ms-2"
                          color="secondary"
                          onClick={resetFilter}
                        >
                          Borrar
                        </Button>
                      ) : null}
                    </Col>
                  </Row>
                </Form>
                {consignments.length > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="w-auto">Ticket</th>
                            <th>Código cliente</th>
                            <th>Valor</th>
                            <th>Tipo</th>
                            <th>Medio de pago</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          {consignments.map((abono, idx) => (
                            <tr key={idx}>
                              <th scope="row">{abono.ticket}</th>
                              <td>{abono.client}</td>
                              {abono.type === "Débito" ? (
                                <>
                                  <td>
                                    $ -{abono.value.toLocaleString("es-CO")}
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        "badge rounded-pill bg-danger bg-soft text-danger"
                                      }
                                    >
                                      <b>Deuda</b>
                                    </span>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td>
                                    $ {abono.value.toLocaleString("es-CO")}
                                  </td>
                                  <td>
                                    <span
                                      className={
                                        "badge rounded-pill bg-success bg-soft text-success"
                                      }
                                    >
                                      <b>Abono</b>
                                    </span>
                                  </td>
                                </>
                              )}
                              <td>{abono.payment_method}</td>
                              <td>{abono.created_date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AccountDetail;
